import Swiper from 'swiper/bundle';

let swiper_banner = new Swiper('.swiper-banner', {
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  speed: 1200,
  navigation: {
    nextEl: '.swiper-img-next',
    prevEl: '.swiper-img-prev',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});

let swiper_partner = new Swiper('.swiper-partner', {
  loop: true,
  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
  },
  speed: 1200,
  slidesPerView: 4,
  spaceBetween: 60,
});

let swiper_member = new Swiper('.swiper-member', {
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  speed: 1200,
  slidesPerView: 4,
  spaceBetween: 60,
});

let overlay = document.getElementById('overlay');
let play = document.getElementById('play');
let video = document.getElementById('video');

play.addEventListener('click', () => {
  overlay.classList.toggle('hidden');
  video.play();
});

video.addEventListener('pause', () => {
  overlay.classList.toggle('hidden');
});

// let videos = document.getElementsByTagName('video');
// let fraction = 0.8;
//
// function checkScroll () {
//   for (let i = 0; i < videos.length; i++) {
//     let video = videos[i];
//     let x = video.offsetLeft;
//     let y = video.offsetTop;
//     let w = video.offsetWidth;
//     let h = video.offsetHeight;
//     let r = x + w; //right
//     let b = y + h; //bottom
//     let visibleX;
//     let visibleY;
//     let visible;
//     visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
//     visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));
//     visible = visibleX * visibleY / (w * h);
//
//     if (visible > fraction) {
//       video.play();
//     } else {
//       video.pause();
//     }
//   }
// }
//
// window.addEventListener('scroll', checkScroll, false);
// window.addEventListener('resize', checkScroll, false);

// let swiper_two = new Swiper('.swiper-two', {
//   loop: true,
//   autoplay: {
//     delay: 0,
//     disableOnInteraction: false,
//   },
//   speed: 3000,
//   breakpoints: {
//     0: {
//       slidesPerView: 2,
//       spaceBetween: 30,
//     },
//     768: {
//       slidesPerView: 3,
//       spaceBetween: 30,
//     },
//     1280: {
//       slidesPerView: 4,
//       spaceBetween: 30,
//     },
//   },
// });
